export const HYPER_SDK_DIV_ID = "HyperSDKDiv";

export const SUCCESS_STATUSES = new Set([
  "CHARGED",
  "COD_INITIATED",
  "PARTIAL_CHARGED",
  "AUTHORIZED",
]);

export const PENDING_STATUSES = new Set([
  "NEW",
  "PENDING_VBV",
  "AUTHORIZING",
  "STARTED",
  "AUTO_REFUNDED",
  "CAPTURE_INITIATED",
  "VOID_INITIATED",
]);

export const FAILED_STATUSES = new Set([
  "AUTHENTICATION_FAILED",
  "AUTHORIZATION_FAILED",
  "JUSPAY_DECLINED",
  "CAPTURE_FAILED",
  "VOID_FAILED",
  "VOIDED",
  "NOT_FOUND",
]);

export const CANCEL_STATUSES = new Set(["CANCELLED", "backpressed"]);

export const CANCEL_ERROR_CODES = new Set([
  "USER_CANCELLED",
  "USER_ABORTED",
  "JP_002",
]);
